const IMAGE_RE = /\.(png|jpe?g|gif|webp|bmp|svg)$/i;
const VIDEO_RE = /\.(mp4|webm|mov|m4v|ogg)$/i;
const AUDIO_RE = /\.(mp3|wav|m4a|aac|oga)$/i;
const PDF_RE = /\.pdf$/i;

function pathOf(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  try {
    const url = new URL(raw, "https://xpro.local");
    return decodeURIComponent(url.pathname || raw);
  } catch {
    return raw.split("?")[0].split("#")[0];
  }
}

function matches(value, re) {
  return re.test(pathOf(value));
}

function mimeOf(att) {
  return String(att?.mimeType || "").toLowerCase();
}

export function attachmentKind(att) {
  const mime = mimeOf(att);
  const name = att?.fileName;
  const url = att?.fileUrl;
  if (mime.startsWith("image/") || matches(name, IMAGE_RE) || matches(url, IMAGE_RE)) return "image";
  if (mime.startsWith("video/") || matches(name, VIDEO_RE) || matches(url, VIDEO_RE)) return "video";
  if (mime.startsWith("audio/") || matches(name, AUDIO_RE) || matches(url, AUDIO_RE)) return "audio";
  if (mime === "application/pdf" || mime === "application/x-pdf" || matches(name, PDF_RE) || matches(url, PDF_RE)) {
    return "pdf";
  }
  return "file";
}

export function isPreviewableAttachment(att) {
  const kind = attachmentKind(att);
  return kind === "image" || kind === "video" || kind === "pdf";
}
